import InfoIcon from '@mui/icons-material/Info'
import { Box, Grid, Stack, Typography } from '@mui/material'

import { EtaSourceTooltip } from 'components/common'
import {
  POST_COLLECTION_STATUSES,
  FINISHED_STATUSES,
  ETA_POLLING_INTERVAL_MS,
} from 'constants/EntityConstants/Booking'
import { Booking, useGetBookingNextAddressEtaQuery } from 'generated/graphql'

import { getBookingStatus, formatEtaWindow } from './helpers'

interface IContainerStatusProps {
  bookingDetails?: Booking
  isQuote?: boolean
  isQuickQuote?: boolean
}

const ContainerStatus = (props: IContainerStatusProps) => {
  const { bookingDetails, isQuote, isQuickQuote } = props

  const bookingStatus = getBookingStatus(bookingDetails, isQuote, isQuickQuote)

  const shouldFetchEta =
    bookingDetails?.id &&
    bookingDetails?.status &&
    POST_COLLECTION_STATUSES.includes(bookingDetails.status) &&
    !FINISHED_STATUSES.includes(bookingDetails.status)

  const { data: bookingNextAddressEtaData, loading: bookingNextAddressEtaLoading } =
    useGetBookingNextAddressEtaQuery({
      fetchPolicy: 'cache-and-network',
      variables: { bookingId: Number(bookingDetails?.id) },
      skip: !shouldFetchEta,
      pollInterval: shouldFetchEta ? ETA_POLLING_INTERVAL_MS : 0,
    })

  const etaData = bookingNextAddressEtaData?.bookingNextAddressEta

  const displayText = (() => {
    if (bookingNextAddressEtaLoading) {
      return `${bookingStatus} - loading ETA...`
    }

    if (!shouldFetchEta) {
      return bookingStatus
    }

    if (etaData?.nextAddressETA && etaData?.etaWindowMinutes) {
      const etaWindow = formatEtaWindow(new Date(etaData.nextAddressETA), etaData.etaWindowMinutes)
      return `${bookingStatus} - next ETA ${etaWindow}`
    }

    return `${bookingStatus} - ETA not available`
  })()

  return (
    <Grid item>
      {displayText && (
        <Box display='flex' flexDirection='column' alignItems='flex-end'>
          <EtaSourceTooltip
            source={etaData?.etaSource}
            lastUpdatedAt={etaData?.etaLastUpdatedAt}
            hasValue={!!(etaData?.nextAddressETA && etaData?.etaWindowMinutes)}>
            <Typography variant='h5' color='secondary' textAlign='end'>
              {displayText}
            </Typography>
          </EtaSourceTooltip>
          {etaData?.stopName && etaData?.stopAddress && (
            <Stack direction='row' spacing={1}>
              <InfoIcon color='primary' fontSize='small' />
              <Typography color='secondary' textAlign='end'>
                {` ${etaData?.stopName} — ${etaData?.stopAddress}`}
              </Typography>
            </Stack>
          )}
        </Box>
      )}
    </Grid>
  )
}

export default ContainerStatus
